<template>
  <div class="sub-page">
    <div class="sginup">
        <div class="left">
          <!-- <a-select  style="width: 160px;margin-right:20px" @change="handleTeam" placeholder="请选择组别" size="large">
            <a-select-option :value="item.id"  v-for="(item,index) in teamList" :key="index">
                {{item.name}}
            </a-select-option>
          </a-select>
          <a-select  style="width: 160px;margin-right:20px" @change="handleProgram" placeholder="请选择比赛项目" size="large">
              <a-select-option :value="item.id"  v-for="(item,index) in teamList" :key="index">
                  {{item.name}}
              </a-select-option>
          </a-select> -->
          <!-- <a-select  style="width: 160px;margin-right:20px" @change="handledelegation" placeholder="请选择代表团" size="large">
              <a-select-option :value="item.id"  v-for="(item,index) in teamList" :key="index">
                  {{item.name}}
              </a-select-option>
          </a-select> -->
        </div>
        <div class="btn" @click="handleSignup">代表团报名</div>
    </div>
    <div class="main">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Delegation',
  props: {
    
  },
  components:{
  },
  data() {
    return {
      teamList:[
        {name:"青少组"},
        {name:"成年组"},
        {name:"老年组"},
        {name:"残疾人运动组"},
      ],
    }
  },
  mounted() {
    
  },
  methods: {
    handleTeam(){},
    handleProgram(){},
    handledelegation(){},
    handleSignup(){
      this.$router.push({name:"DelegationSignup"})
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page{
    width: 100%;
    padding-top: 100px;
    .sginup{
        width: 1200px;
        display: flex;
        justify-content: space-between;
        margin: 30px auto;
        .btn{
            width: 160px;
            height: 46px;
            text-align: center;
            line-height: 46px;
            color: #FFFFFF;
            border-radius: 6px;
            background-color: #009EDF;
            cursor: pointer;
            font-size: 16px;
        }
        .btn:hover{
            opacity: 0.8;
        }
    }
    .main{
      width: 100%;
      background-color: #FBFBFB;
      border-top: 1px solid  #E4E4E4;
    }
}
</style>



// WEBPACK FOOTER //
// src/district/views/delegation/Home.vue